import type { Persona } from "types/Persona";

type DisabledTooltipProps = {
  currentPersona: Persona;
};
export default function DisabledTooltip({
  currentPersona,
}: DisabledTooltipProps) {
  return (
    <>
      <div>
        They currently selected AI model{" "}
        <span style={{ fontWeight: "bold" }}>{currentPersona.name}</span> is not
        image capable.
      </div>
    </>
  );
}
